import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "@apis/axiosInstance";
import axiosBaseQuery from "../axiosBaseQuery";
import { DomainConfigData, PublicDomainConfigData } from "@callveriq/type/Domain";
import DomainInstance from "@callveriq/utils/helper/DomainInstance";
import PublicDomainInstance from "@callveriq/utils/helper/PublicDomainInstance";

const publicBaseQuery = fetchBaseQuery({
    baseUrl,
});

export const domainApiSlice = createApi({
    reducerPath: "domainApiSlice",
    baseQuery: axiosBaseQuery(),
    endpoints: (builder) => ({
        getDomainConfig: builder.query<DomainInstance, void>({
            query: () => ({
                url: "/app/api/v2/version/",
                method: "GET",
            }),
            transformResponse: (response: DomainConfigData) =>
                new DomainInstance(response),
        }),
        getPublicDomainConfig: builder.query<PublicDomainInstance, void>({
            queryFn: async (_arg, api, extraOptions) => {
                const result = await publicBaseQuery(
                    { url: "/app/api/tenant-config/", method: "GET" },
                    api,
                    extraOptions
                );
                if (result.error) return { error: result.error };
                return {
                    data: new PublicDomainInstance(
                        result.data as PublicDomainConfigData
                    ),
                };
            },
            async onQueryStarted(props, { queryFulfilled }) {
                const { data } = await queryFulfilled;
                const baseUrl = data?.ai_agent_host || "vbprod.callveriq.com";
                localStorage.setItem("aiAgentHostUrl", baseUrl);
            },
        }),
        checkDomainExist: builder.query<
            {
                status: boolean;
            },
            string
        >({
            queryFn: async (name, api, extraOptions) => {
                const result = await publicBaseQuery(
                    {
                        url: "https://app.api.callveriq.com/app/domains/availability?name=teams",
                        method: "GET",
                        params: { name },
                    },
                    api,
                    extraOptions
                );
                if (result.error) return { error: result.error };
                return { data: result.data as { status: boolean } };
            },
        }),
    }),
});

export const {
    useGetDomainConfigQuery,
    useGetPublicDomainConfigQuery,
    useCheckDomainExistQuery,
} = domainApiSlice;
